import { AplicacionLoteResponse } from "../response/AplicacionLoteResponse";

/** Lote aplicado a guardar. La lista se reemplaza completa en cada guardado,
 *  igual que los detalles de producto.
 *
 *  Según el método tiene que ir `cantidad` (recipientes) o `plantas` (drench),
 *  no las dos ni ninguna — el server lo valida y responde `InvalidArgument`. */
export type AplicacionLoteRequest = {
  /** Lote al que se le aplicó. Tiene que ser de la finca de la aplicación. */
  loteId: string;
  /** Nombre del lote. **Solo para la UI**: el server lo resuelve del lote y no
   *  lo lee del request. Se guarda acá para poder pintar la fila de la tabla
   *  sin volver a buscar el lote en el listado. */
  loteNombre: string;
  /** Recipientes aplicados, o `null` en drench. */
  cantidad: number | null;
  /** Plantas tratadas, o `null` fuera de drench. */
  plantas: number | null;
};

export const fx_createAplicacionLoteRequest = (
  response: AplicacionLoteResponse,
): AplicacionLoteRequest => {
  return {
    loteId: response.loteId,
    loteNombre: response.loteNombre,
    cantidad: response.cantidad,
    plantas: response.plantas,
  };
};
